// extracted by mini-css-extract-plugin
module.exports = {"resize":"Resize_resize__3c-vV","houseBase":"Resize_houseBase__lhJBo"};